export class CheckboxModel {
  key: string;
  value: string;
  ariaLabel: string;
  checked: boolean;

  constructor(key: string, value: string, ariaLabel: string, checked: boolean) {
    this.key = key;
    this.value = value;
    this.ariaLabel = ariaLabel;
    this.checked = checked;
  }
}
